import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IThankYou {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  logo_image?: string;
  logo_alt?: string;
  desktop_bg_image?: string;
  mobile_bg_image?: string;
  alt_image?: string;
  gradient_start_color?: string;
  gradient_end_color?: string;
  description?: string;
  referral_description?: string;
  influencer_description?: string;
}

export async function createThankYou(payload: Partial<IThankYou>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.THANK_YOU.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateThankYou(id: number, payload: Partial<IThankYou>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.THANK_YOU.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

